<app-modal-header (closeModal)="close()"> </app-modal-header>
<app-modal-body>
  <h1 class="fs-5 text-truncate pe-2">{{ 'VIDEO_CALL' | translate }}</h1>
  <p>
    {{ 'CHOOSE_BETWEEN_STARTING_A_VIDEO_CALL_NOW_OR_SCHEDULE_ONE_FOR_THE_NEAR_FUTURE' | translate }}
  </p>
  <form [formGroup]="form">
    <div class="d-flex gap-2">
      <button
        type="button"
        class="btn {{
          form.get('step')?.value === 'immediate'
            ? 'btn-primary border-2'
            : 'btn-outline-secondary bg-color-contrast border-bg-color-contrast'
        }}"
        (click)="onChangeType('immediate')"
      >
        {{ 'IMMEDIATE' | translate }}
      </button>
      <button
        type="button"
        class="btn {{
          form.get('step')?.value === 'later'
            ? 'btn-primary border-2'
            : 'btn-outline-secondary bg-color-contrast border-bg-color-contrast'
        }}"
        (click)="onChangeType('later')"
      >
        {{ 'LATER' | translate }}
      </button>
    </div>
    @if (form.dirty && form.touched && form.get('step')?.getError('required')) {
      <div class="text-danger mt-2">{{ 'SELECT_IMEDIATE_LATER' | translate }}</div>
    }

    @if (form.get('step')?.value === 'later') {
      <div class="row justify-content-center">
        <div class="col-lg-12 col-12">
          <div class="input-group mt-3">
            <div class="input-group-text font-monsterat">{{ utcInfo }}</div>
            <input
              type="date"
              class="form-control"
              formControlName="date"
              aria-label="Date"
              [min]="dateToday"
              [max]="matchAppEndDate"
            />
            <input type="time" class="form-control" aria-label="Time" formControlName="time" />
          </div>
        </div>
        @if (
          form.dirty &&
          form.touched &&
          (form.get('date')?.getError('required') || form.get('time')?.getError('required'))
        ) {
          <div class="text-danger mt-2">{{ 'SELECT_DATE_AND_TIME' | translate }}</div>
        }
      </div>
    }
  </form>
</app-modal-body>
<app-modal-footer classList="d-flex justify-content-center">
  <button
    class="btn btn-primary rounded-5"
    (click)="createVideoMeeting()"
    [disabled]="activeButton === ActiveButton.CREATE_VIDEO_MEETING && isHttpRequestRunning"
  >
    @if (activeButton === ActiveButton.CREATE_VIDEO_MEETING && isHttpRequestRunning) {
      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
    }
    {{ 'CREATE' | translate }}
  </button>
</app-modal-footer>
